import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoDatePicker,
    RaikoGridFourColumn,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    RaikoTimePicker,
    RaikoButtonSecondary, RaikoFlexFirstChildGrowOne
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import ElectionBasicInfo from "./ElectionBasicInfo";
import ElectionResult from "./ElectionResult";

export default function ElectionDetails() {


    const [tabValue, setTabValue] = useState(ElectionDetailsInfoTabTypes.BasicInfo.id);

    function handleChangeTabMenu(event, newValue) {
        setTabValue(newValue)
    }

    const navigate = useNavigate()

    return (

        <>
            <Helmet>
                <title>{RouteHelper.ElectionDetails.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            className={css`flex-grow: 1;
                              gap: .5rem;`}
                            breadCrumbItems={[
                                raikoBreadCrumbItemGenerator(
                                    RouteHelper.Election.name,
                                    RouteHelper.Election.globalUrl
                                ),
                                raikoBreadCrumbItemGenerator(
                                    RouteHelper.ElectionDetails.name
                                )
                            ]}
                        />
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1);
                            }}/>
                    </RaikoFlexFirstChildGrowOne>
                    <TabContext value={tabValue}>
                        <Box sx={{borderBottom: 1, borderColor: 'divider'}}
                             className={css`
                               border-color: var(--header-border-bottom-color) !important;
                               margin-top: 24px;
                             `}>
                            <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                                <Tab
                                    value={ElectionDetailsInfoTabTypes.BasicInfo.id}
                                    label={ElectionDetailsInfoTabTypes.BasicInfo.title}
                                />
                                <Tab
                                    value={ElectionDetailsInfoTabTypes.Result.id}
                                    label={ElectionDetailsInfoTabTypes.Result.title}
                                />
                            </TabList>
                        </Box>
                        <TabPanel value={ElectionDetailsInfoTabTypes.BasicInfo.id}>
                            <ElectionBasicInfo/>
                        </TabPanel>
                        <TabPanel value={ElectionDetailsInfoTabTypes.Result.id}>
                            <ElectionResult/>
                        </TabPanel>

                    </TabContext>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
export const ElectionDetailsInfoTabTypes = {
    BasicInfo: {
        id: "basic-info",
        title: "اطلاعات پایه"
    },
    Result: {
        id: "result",
        title: "نتیجه انتخابات"
    }
}